module.exports = __webpack_public_path__ + "static/img/Piggy-Bank.1ad2e7b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/Piggy-Bank.png
// module id = ui6a
// module chunks = 1